import Icon from '@ant-design/icons';
import { MouseEventHandler } from 'react';

interface IProps {
    className?: string;
    onClick?: MouseEventHandler<HTMLSpanElement>;
}

export const OcrEditSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2076_447)">
                    <path
                        d="M17.5 8.59375V15.5C17.5 16.6046 16.6046 17.5 15.5 17.5H4.5C3.39543 17.5 2.5 16.6046 2.5 15.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H11.4062"
                        stroke="#9655FF"
                        strokeOpacity="0.85"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M16.2862 6.54869L10.3436 12.4857C10.2099 12.6193 10.041 12.7122 9.8566 12.7538L7.46294 13.293C7.24798 13.3414 7.0559 13.1493 7.10436 12.9343L7.64338 10.5432C7.68501 10.3586 7.7782 10.1895 7.91213 10.0557L13.8544 4.11904L16.2862 6.54869ZM17.0404 5.79507L14.6091 3.36542L15.663 2.31205C15.8631 2.11224 16.1342 2 16.4169 2C16.6997 2 16.9708 2.11224 17.1708 2.31205L18.0948 3.23231C18.1939 3.33137 18.2725 3.44898 18.3262 3.57843C18.3798 3.70788 18.4074 3.84662 18.4074 3.98674C18.4074 4.12686 18.3798 4.2656 18.3262 4.39505C18.2725 4.52449 18.1939 4.64211 18.0948 4.74117L17.0404 5.79507Z"
                        fill="#9655FF"
                        fillOpacity="0.85"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_2076_447">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
    />
);

export const NewCreateQuestionSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.76455 6.49968C1.76455 3.88448 3.8846 1.76443 6.4998 1.76443C9.11501 1.76443 11.2351 3.88448 11.2351 6.49968C11.2351 9.11489 9.11501 11.2349 6.49981 11.2349H3.03314C2.33252 11.2349 1.76455 10.667 1.76455 9.96635V6.49968Z"
                    stroke="#1B1B48"
                    strokeOpacity="0.85"
                    strokeWidth="0.9295"
                />
                <rect x="3.5752" y="6.22253" width="5.57143" height="0.928571" rx="0.464286" fill="#1B1B48" fillOpacity="0.85" />
                <rect
                    x="5.89648"
                    y="9.47253"
                    width="5.57143"
                    height="0.928572"
                    rx="0.464286"
                    transform="rotate(-90 5.89648 9.47253)"
                    fill="#1B1B48"
                    fillOpacity="0.85"
                />
            </svg>
        )}
    />
);

export const KnowledgeSliceVideoIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="1.55"
                    y="11.2391"
                    width="8.4"
                    height="10.9"
                    rx="1.95"
                    transform="rotate(-90 1.55 11.2391)"
                    stroke="#9655FF"
                    strokeOpacity="0.45"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
                <path
                    d="M8.82874 7.43534L5.74641 9.17515C5.66271 9.2224 5.5669 9.2482 5.46883 9.24991C5.37076 9.25161 5.27397 9.22916 5.18841 9.18485C5.10285 9.14054 5.03161 9.07598 4.98202 8.99781C4.93243 8.91964 4.90627 8.83067 4.90625 8.74007V5.25993C4.90627 5.16933 4.93243 5.08036 4.98202 5.00219C5.03161 4.92402 5.10285 4.85946 5.18841 4.81515C5.27397 4.77084 5.37076 4.74839 5.46883 4.75009C5.5669 4.7518 5.66271 4.7776 5.74641 4.82485L8.82874 6.56466C8.90951 6.61021 8.97625 6.67417 9.02256 6.75041C9.06887 6.82664 9.09319 6.91259 9.09319 7C9.09319 7.08741 9.06887 7.17336 9.02256 7.24959C8.97625 7.32583 8.90951 7.38979 8.82874 7.43534Z"
                    fill="#9655FF"
                />
            </svg>
        )}
    />
);

export const KnowledgeSliceDocumentIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="5.3" y1="5.88896" x2="8.7" y2="5.88896" stroke="#9655FF" strokeWidth="1.1" strokeLinecap="round" />
                <line x1="5.3" y1="8.38896" x2="7.2" y2="8.38896" stroke="#9655FF" strokeWidth="1.1" strokeLinecap="round" />
                <path
                    d="M9.69113 3.39627L9.69112 3.39627L9.69322 3.39861L11.0852 4.95299C11.1591 5.03552 11.2 5.14242 11.2 5.2532V10.6863C11.2 11.4871 10.5508 12.1363 9.75 12.1363H4.25C3.44919 12.1363 2.8 11.4871 2.8 10.6863V3.59891C2.8 2.79811 3.44918 2.14892 4.24999 2.14891L8.38419 2.14888C8.51304 2.14888 8.63571 2.20411 8.72113 2.30059L9.69113 3.39627Z"
                    stroke="#9655FF"
                    strokeOpacity="0.45"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
            </svg>
        )}
    />
);

export const CollectedKnowledgeSliceVideoIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <rect
                    x="1.00006"
                    y="15.3834"
                    width="12.6667"
                    height="16"
                    rx="3.33333"
                    transform="rotate(-90 1.00006 15.3834)"
                    fill="url(#paint0_linear_48_818)"
                />
                <path
                    d="M11.4387 9.57886L7.32889 11.8986C7.2173 11.9616 7.08955 11.996 6.95879 11.9983C6.82803 12.0006 6.69897 11.9706 6.58489 11.9115C6.47081 11.8525 6.37582 11.7664 6.3097 11.6622C6.24358 11.5579 6.20871 11.4393 6.20868 11.3185V6.67832C6.20871 6.55752 6.24358 6.4389 6.3097 6.33467C6.37582 6.23044 6.47081 6.14436 6.58489 6.08528C6.69897 6.0262 6.82803 5.99626 6.95879 5.99853C7.08955 6.00081 7.2173 6.03521 7.32889 6.09821L11.4387 8.41796C11.5464 8.4787 11.6353 8.56398 11.6971 8.66562C11.7588 8.76727 11.7913 8.88186 11.7913 8.99841C11.7913 9.11496 11.7588 9.22956 11.6971 9.3312C11.6353 9.43285 11.5464 9.51813 11.4387 9.57886Z"
                    fill="white"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_48_818"
                        x1="12.1303"
                        y1="15.3834"
                        x2="-0.518469"
                        y2="26.5624"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#CCD0FF" />
                        <stop offset="1" stop-color="#7D87FF" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const CollectedKnowledgeSliceDocumentIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                    d="M2.14532 4.51661C2.14532 2.67567 3.63769 1.18329 5.47863 1.18327L10.1463 1.18324C11.1008 1.18323 12.0094 1.59238 12.6421 2.30703L13.4777 3.25089L15.0044 4.95563C15.5519 5.56696 15.8546 6.35875 15.8546 7.17939V13.8499C15.8546 15.6908 14.3622 17.1832 12.5212 17.1832H5.47866C3.63771 17.1832 2.14532 15.6908 2.14532 13.8499V4.51661Z"
                    fill="url(#paint0_linear_46_1542)"
                />
                <line x1="6.54668" y1="7.3744" x2="11.4532" y2="7.3744" stroke="white" stroke-width="1.58739" stroke-linecap="round" />
                <line x1="6.54675" y1="11.3745" x2="9.2886" y2="11.3745" stroke="white" stroke-width="1.58739" stroke-linecap="round" />
                <defs>
                    <linearGradient
                        id="paint0_linear_46_1542"
                        x1="15.8289"
                        y1="13.6819"
                        x2="3.64943"
                        y2="0.949067"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#69A5FF" />
                        <stop offset="1" stop-color="#C4DCFF" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);
